class MedicamentoAnvisaItensController extends AbstractCrudController

  configure: (configs) ->
    configs.model = 'medicamentoAnvisaItens'
    configs.module = 'eficiencia-fiscal'
    configs.folder = 'configuracao/icms/desvios-st/tabs/farmaceutico/anvisa-itens'

    @setModal('modalImportar', 'importar', 'medicamentoAnvisaItensImportarController')

  importar: ->
    @modalImportar(@modalResolve(), => @loadData())

angular.module('eficienciaFiscalModule').controller('medicamentoAnvisaItensController', MedicamentoAnvisaItensController)


class MedicamentoAnvisaItensImportarController extends AbstractController
  @$inject = [ '$injector', '$uibModalInstance', 'FileUploader' ]

  constructor: ($injector, @modalInstance, FileUploader) ->
    super($injector)

    @submitTracker = @promiseTracker()
    @url = "/api/eficiencia-fiscal/desvio-st-medicamento-anvisa-itens"

    @uploader = new FileUploader(
      url: @url
      headers: cbk.getHeaders()
    )


    @uploader.onBeforeUploadItem = (item) =>
      item.formData.push({dataVigencia: @dataVigencia})
      return item

    @uploader.onCompleteItem = (fileItem, response, status, headers) =>
      if response.success
        @Alert.success("A planilha de aliquotas de antecipação foi importado com sucesso.", 'Sucesso')
        @modalInstance.close(new Retorno(response.success, null, response.data))
      else
        @Alert.warning('Ocorreu um erro ao realizar a importação.', 'Operação não realizada', false)

  importar: () ->
    @uploader.uploadAll()

angular.module('eficienciaFiscalModule').controller('medicamentoAnvisaItensImportarController', MedicamentoAnvisaItensImportarController)